import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const phylum = defineConnector({
  identifier: "phylum",
  name: "phylum",
  tagLine: "Supply chain risk analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api.phylum.io/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://docs.phylum.io/knowledge_base/api-keys](https://docs.phylum.io/knowledge_base/api-keys) and [https://docs.phylum.io/package_firewall/api](https://docs.phylum.io/package_firewall/api) to create an API key for the phylum API. Phylum documents requests as `Authorization: Bearer <API_KEY>`.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.phylum.io/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.phylum.io/")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
